import { MenuItem, TextField, Typography } from "@mui/material";
import React, { useContext, useState } from "react";
import { AppReleasesFeatureContext } from "../../../globalContext";
import { HelmetDexteel } from "../../../helmet/HelmetDexteel";
import { TableAppReleases } from "./components/TableAppReleases";
import type { AppReleaseApp } from "./models/AppRelease";

const appKey = (app: AppReleaseApp) => `${app.appCode}|${app.platform}`;

export const AppReleasesPage = () => {
	const apps = useContext<AppReleaseApp[]>(AppReleasesFeatureContext);
	const [selectedKey, setSelectedKey] = useState<string>(() =>
		apps.length ? appKey(apps[0]) : "",
	);

	const selectedApp =
		apps.find((app) => appKey(app) === selectedKey) ?? apps[0] ?? null;

	if (!selectedApp) {
		return (
			<>
				<HelmetDexteel title="App Releases" />
				<Typography variant="body1" color="textSecondary" p={2}>
					No mobile apps are configured for this site.
				</Typography>
			</>
		);
	}

	const appSelector =
		apps.length > 1 ? (
			<TextField
				select
				size="small"
				label="App"
				value={appKey(selectedApp)}
				onChange={(event) => setSelectedKey(event.target.value)}
				sx={{ minWidth: 220 }}
			>
				{apps.map((app) => (
					<MenuItem key={appKey(app)} value={appKey(app)}>
						{app.label} ({app.platform})
					</MenuItem>
				))}
			</TextField>
		) : (
			<Typography variant="subtitle1" color="textSecondary">
				{selectedApp.label} ({selectedApp.platform})
			</Typography>
		);

	return (
		<>
			<HelmetDexteel title="App Releases" />
			<TableAppReleases
				key={appKey(selectedApp)}
				app={selectedApp}
				appSelector={appSelector}
			/>
		</>
	);
};
